import React, { ReactElement, useState } from "react";
import ReCAPTCHA from "react-google-recaptcha";
// import { useSendResetPasswordMutation } from "../../../__generated__/legacy";
import ResetSuccess from "../password-reset-success/ResetSuccess";
// import Api from "../../../api";
import "./ResetPassword.css";

const SITE_KEY = process.env.REACT_APP_SITE_KEY;

interface UserCredentials {
    email: string;
    validation: string;
}

/**
 * This component renders the password reset form
 * stores email entered in state on submittal
 *
 * Needs to be hooked up to API to reset password
 *
 * uses history to redirect
 * state : uses state to store client emails
 *
 * Homepage -> App -> Password Reset -> Reset Success Page
 */
function PasswordReset(): ReactElement {
    const defaultData = { email: "", validation: "" };
    const [resetData, setResetData] = useState<UserCredentials>(defaultData);
    const [passwordReset, setPasswordReset] = useState(false);
    // const [sendResetPassword] = useSendResetPasswordMutation();

    const handleChange = (evt: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = evt.target;
        setResetData(data => ({
            ...data,
            [name]: value,
        }));
    };

    const onChange = (value: string | null) => {
        if (value) {
            setResetData(data => ({
                ...data,
                validation: value,
            }));
        }
    };

    async function handleSubmit(evt: React.FormEvent<HTMLFormElement>) {
        evt.preventDefault();
        if (resetData) {
            // await sendResetPassword({ variables: { email: resetData.email, recaptchaValidation: resetData.validation } });
        }
        setResetData(defaultData);
        setPasswordReset(true);
    }

    return (
        <div className="password-reset-container">
            {!passwordReset ? (
                <div className="password-reset shadow-lg border p-4">
                    <form className="password-reset-text" onSubmit={handleSubmit}>
                        <div className="form-group">
                            <label
                                className="password-reset-text"
                                htmlFor="email"
                            >
                                Enter your email to reset your password
                                <input
                                    type="email"
                                    onChange={handleChange}
                                    id="email"
                                    name="email"
                                    value={resetData.email}
                                    className="form-control Reset-text mt-2"
                                    aria-describedby="emailHelp"
                                    placeholder="user@foqal.com"
                                    required
                                />
                            </label>
                        </div>
                        <div className="recaptcha mt-2 d-flex flex-row-reverse mb-2">
                            {SITE_KEY && (
                                <ReCAPTCHA
                                    sitekey={SITE_KEY}
                                    onChange={onChange}
                                />
                            )}
                        </div>
                        <div className="d-flex flex-row-reverse">
                            <button type="submit" className="reset-button">
                                Reset
                            </button>
                        </div>
                    </form>
                </div>
            ) : <ResetSuccess />}

        </div>
    );
}

export default PasswordReset;
